// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"371e8a80","513":"eac982f5","703":"2f751507","787":"032120af"}[chunkId] + ".chunk.js";
};